import {
  DeviceSources,
  MOBILE_DETECTION_REGEXP
} from './mobile-detection-types'

export const isMobile = (userAgent: string): boolean =>
  MOBILE_DETECTION_REGEXP.test(userAgent)

export const getDeviceSource = (userAgent: string): DeviceSources =>
  isMobile(userAgent)
    ? DeviceSources.browser_mobile
    : DeviceSources.browser_computer

